<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="c-email-page" fxLayout="column" fxLayoutAlign="center center">
    <div class="c-login-logo">
      <img [src]="logoURL ? logoURL : 'assets/images/logo-brand-pmc.svg'" />
    </div>
    <div class="c-status-message">
      <p
        *ngIf="isValidateError"
        class="u-background-color-error u-font-color-white u-padding-10 u-text-center"
      >
        {{ "email_form.email_link.validate_error_msg" | translate }}
      </p>
      <p
        *ngIf="isSuccess"
        class="u-background-color-success u-font-color-white u-padding-10 u-text-center "
      >
        {{ "email_form.email_link.success_msg" | translate }}
      </p>
    </div>
    <div class="c-email-box">
      <mat-form-field class="mat-block" appearance="fill">
        <mat-icon matPrefix>person</mat-icon>
        <input
          matInput
          [placeholder]="'email_form.email' | translate"
          formControlName="emailId"
          required
          value=""
          (keydown)="noWhiteSpaceAllow($event)"
        />
        <mat-error
          id="matEmailRequired"
          class="error-message"
          *ngIf="hasError('emailId','required')"
        >
          {{ "email_form.email_mandatory" | translate }}
        </mat-error>
        <mat-error
          id="matEmailInvalid"
          class="error-message"
          *ngIf="
    (form.get('emailId').dirty || form.get('emailId').touched) && form.get('emailId').hasError('email')
  "
        >
          {{ "email_form.email_validation" | translate }}
        </mat-error>
      </mat-form-field>
      <button
        mat-button
        mat-flat-button
        color="primary"
        class="c-email-button u-margin-top-5"
        *ngIf="!isSuccess"
        [disabled]="!form.valid"
      >
        {{ "email_form.btn_next" | translate }}
      </button>
      <button
        mat-button
        mat-flat-button
        color="primary"
        class="c-email-button u-margin-top-5"
        routerLink="/login"
        *ngIf="isSuccess"
      >
        {{ "email_form.btn_login" | translate }}
      </button>
    </div>
  </div>
</form>
